import { directive as onClickaway } from 'vue-clickaway';

export default {
  name: 'InputSelect',
  directives: {
    onClickaway: onClickaway
  },
  props: {
    type: {
      type: String,
      default: 'objectData'
    },
    value: {},
    label: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemTitle: {
      type: String,
      default: 'title'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      selectedData: this.value
    };
  },

  created() {
    this.selectedData = this.value;
  },
  mounted() {},
  watch: {
    value: {
      immediate: false,
      handler(newVal) {
        if (newVal !== this.selectedData) {
          this.selectedData = newVal;
        }
      }
    }
  },
  computed: {
    selectedTitle() {
      if (!this.selectedData) return null;
      return this.type === 'objectData' ? this.selectedData[this.itemTitle] : this.selectedData;
    }
  },
  methods: {
    onChangeSelect(item) {
      if (item?.id === this.selectedData?.id) {
        this.selectedData = null;
      } else {
        this.selectedData = item;
      }

      this.$emit('change', this.selectedData);

      setTimeout(() => {
        this.isOpen = false;
      }, 300);
    },
    onAway() {
      this.isOpen = false;
    }
  }
};
